module.exports = __webpack_public_path__ + "static/media/selector.d051959f.svg";